import React, { useState } from 'react'
import { makeStyles } from "@mui/styles";

export function useForm(initialFValues, validate, validateOnChange = false ) {


    const [values, setValues] = useState(initialFValues);
    const [errors, setErrors] = useState({});

    const handleInputChange = e => {
        const { name, value } = e.target
        if(e.target.name === 'billing_postal_code'){
            setValues({
                ...values,
                [name]: value.replace(/\s/g, ''),
            });
       }else{
            setValues({
                ...values,
                [name]: value
            })
        }
        if (validateOnChange)
            validate({ [name]: value })
    }

    const resetForm = () => {
        setValues(initialFValues);
        setErrors({})
    }


    return {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    }
}


const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiFormControl-root': {
            width: '80%',
            margin: 20
        }
    }
}))

export function Form(props) {

    const classes = useStyles();
    const { children, ...other } = props;
    return (
        <form className={classes.root} autoComplete="off" {...other}>
            {props.children}
        </form>
    )
}

